import { CountryEnum } from '@sancare/typescript-commons/src/types/country'
import type { Finess } from '@sancare/typescript-commons/src/types/finess'

import { AutomationModeEnum, AutomationTypeEnum } from '@/store/modules/automation/types'

export { CountryEnum }

export enum PmsiTypeEnum {
  MCO = 'mco',
  SMR = 'smr',
}
export const pmsiTypesLabels = {
  [PmsiTypeEnum.MCO]: 'MCO',
  [PmsiTypeEnum.SMR]: 'SMR',
}

export enum ModeEnum {
  AUTOMATION = 'automation',
  NEW_CODING = 'new-coding',
  OPTIMIZABLE = 'optimizable',
  QUALITY_STAYS = 'quality-stays',
  DIALYSIS = 'dialysis',
}

export enum PrivacyEnum {
  PRIVATE_SEARCH = 'privateSearch',
  TEAM_SEARCH = 'teamSearch',
  PUBLIC_SEARCH = 'publicSearch',
  SANCARE_SEARCH = 'sancareSearch',
}

export enum SearchGroupPrivacyEnum {
  PRIVATE = 'private',
  PUBLIC = 'public',
  SANCARE = 'sancare',
  SYSTEM = 'system',
}

export type StayListColumn = {
  icon?: string
  name?: string
  isTranslated?: boolean
  label: string | null
  country: CountryEnum[]
  order: string
  mode: (ModeEnum | AutomationModeEnum)[]
  automationType?: AutomationTypeEnum[]
  isDefault: boolean
  invertedOrder: boolean
  columnGroup: 'administrativeInfo' | 'sancareState' | 'sancareCodingAssistance' | 'initialGrouping' | 'currentGrouping'
}

export type StayListColumns = { [key: string]: StayListColumn }

type Team = {
  id: number
  name: string
}

export type User = {
  id: number
  username: string
  firstName: string | null
  lastName: string | null
  email: string | null
  role: string
  sancareUser: boolean
  createdFromLdap: boolean
  createdFromOidc: boolean
  teamMode: boolean
  team: Team | null
  disabled: boolean
  // type missing for settings
  settings: unknown[]
  legalEntities: Finess[]
  geographicEntities: Finess[]
  editableRoles?: string[]
}

